import { mapState as rootMapState } from 'pinia';
import { usePageStore } from "@/store";
import { mapState } from '@/store/helpers';
import { asyncData, loadData, getSocialLinks } from './asyncData';
import { mapAsyncData } from '@/plugins/asyncData';
import { normal } from '../defaultSpacing';
import util from '@/common/util';
import useStore from './_store';

export default {
    data: function() {
        // /**
        //  * cms The preview data is not limited by the package ，site The actual display must have a package and be within the validity period 
        //  */
        // let delegateUserId;
        // if (util.inCmsPageEditor && window.top.cmsAppVm) {
        //     delegateUserId = window.top.cmsAppVm.$DELEGATEUSERID;
        // } else {
        //     delegateUserId =
        //         document.querySelector('#delegateUserId')?.value || 0;
        // }
        return {
            title: '',
            ...normal,
            // prevent load more too fast
            isLoadingMore: false,
        };
    },
    computed: {
        ...rootMapState(usePageStore, {
            delegateUserId: store => store.page.delegateUserId,
        }),
        ...mapState({
            socialLinks: store => store.socialLinks,
            posts: store => store.posts,
            hasMore: store => store.hasMore,
        }),
    },
    created() {
        this._debounceRefresh = util.debounce(this.refresh, 100).bind(this);
    },
    asyncData: mapAsyncData(asyncData),
    _getUseStore: useStore,
    methods: {
        ...mapAsyncData({ loadData, getSocialLinks }),
        refresh() {
            this.loadData(true);
            this.getSocialLinks();
        },
        loadMore() {
            if (this.isLoadingMore) {
                return;
            }
            this.isLoadingMore = true;
            this.loadData().finally(_ => {
                this.isLoadingMore = false;
            });
        },
    }
};
